// src/components/atom/Clock.js
import React, { useEffect, useState } from 'react';

const Clock = ({ timeString = "" }) => {
  // Logge, was übergeben wird:
  console.log("Clock Props received:", timeString);

  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    // Definiere updateTime inline im useEffect, um stets den aktuellen timeString zu nutzen.
    const updateTime = () => {
      if (!timeString) return;
      
      // Erwartetes Format: "YYYY-MM-DD HH:MM"
      const parts = timeString.split(" ");
      if (parts.length !== 2) return;
      
      const timeParts = parts[1].split(":");
      if (timeParts.length < 2) return;
      
      // Nehme die Stunde aus dem API-Zeitstring (fix)
      const baseHour = parseInt(timeParts[0], 10);
      // Hole die aktuellen Minuten vom Gerät
      const now = new Date();
      const minutes = now.getMinutes();
      
      // Formatieren: Beide als zweistellig (z.B. "08:05")
      const formattedHour = baseHour.toString().padStart(2, '0');
      const formattedMinute = minutes.toString().padStart(2, '0');
      
      setCurrentTime(`${formattedHour}:${formattedMinute}`);
    };

    // Initialer Aufruf beim Mount
    updateTime();
    // Aktualisiere die Uhrzeit alle 5 Sekunden (unabhängig davon, ob timeString sich ändert)
    const timer = setInterval(updateTime, 5000);
    return () => clearInterval(timer);
  }, [timeString]); // useEffect wird erneut ausgeführt, wenn sich timeString ändert

  return <div className="clock">{currentTime || "00:00"}</div>;
};

export default Clock;
